<div class="rn-page">

  <!-- Success Message -->
  <div class="rn-success-banner" *ngIf="showSuccessMessage">
    <div class="rn-success-content">
      <span>✅</span>
      <span>{{ successMessage }}</span>
    </div>
  </div>

  <!-- Error Message -->
  <div class="rn-error-banner" *ngIf="errorMessage && !showModal && !showDeleteModal">
    <div class="rn-error-content">
      <span>⚠️</span>
      <span>{{ errorMessage }}</span>
    </div>
    <button class="rn-error-close" (click)="errorMessage = ''">×</button>
  </div>

  <!-- Page Header -->
  <div class="rn-page-header">
    <div class="rn-page-header-left">
      <div>
        <h2>Menu Management</h2>
        <p class="rn-sub">Create and manage your application menus</p>
      </div>
    </div>
    <button class="rn-add-btn" (click)="openCreateModal()">
      <span>＋</span>
      <span>New Menu</span>
    </button>
  </div>

  <!-- Search Bar -->
  <div class="rn-search-section">
    <input
      type="text"
      class="rn-search-input"
      placeholder="Search by name, code, or description..."
      [value]="searchQuery"
      (input)="onSearch($any($event.target).value)"
    />
    <i>🔍</i>
  </div>

  <!-- Loading State -->
  <div class="rn-loading" *ngIf="loading">
    <span class="rn-spin"></span>
    <span>Loading menus...</span>
  </div>

  <!-- Empty State -->
  <div class="rn-empty" *ngIf="!loading && filteredMenus.length === 0">
    <div class="rn-empty-visual">
      <div class="rn-empty-circle c1"></div>
      <div class="rn-empty-circle c2"></div>
      <span class="rn-empty-icon">📋</span>
    </div>
    <h3 class="rn-empty-title">No Menus Found</h3>
    <p class="rn-empty-sub">
      {{ searchQuery ? 'Try adjusting your search criteria' : 'Create your first menu to get started' }}
    </p>
    <button class="rn-add-btn" (click)="openCreateModal()" *ngIf="!searchQuery">
      <span>＋</span>
      <span>Create Menu</span>
    </button>
  </div>

  <!-- Menu List -->
  <div class="rn-list" *ngIf="!loading && filteredMenus.length > 0">
    <div class="rn-card" *ngFor="let menu of paginatedMenus">
      <div class="rn-card-accent"></div>
      <div class="rn-card-content">

        <!-- Card Top -->
        <div class="rn-card-top">
          <div class="rn-card-doctor">
            <div class="rn-avatar">{{ menu.menuName.charAt(0).toUpperCase() }}</div>
            <div class="rn-doctor-details">
              <div class="rn-doctor-name">{{ menu.menuName }}</div>
              <div class="rn-badges">
                <span class="rn-role-pill">{{ menu.menuCode }}</span>
                <span class="rn-dx-pill" [ngClass]="getStatusClass(menu.isActive)">
                  {{ getStatusText(menu.isActive) }}
                </span>
              </div>
            </div>
          </div>
          <div class="rn-card-right">
            <div class="rn-card-time">
              <span>🕐</span>
              <span>Order: {{ menu.displayOrder }}</span>
            </div>
            <div class="rn-card-actions">
              <button
                class="rn-action-btn edit"
                (click)="openEditModal(menu)"
                title="Edit menu"
              >✏️</button>
              <button
                class="rn-action-btn delete"
                (click)="openDeleteModal(menu)"
                title="Delete menu"
              >🗑️</button>
            </div>
          </div>
        </div>

        <!-- Menu Description -->
        <div class="rn-condition-banner" *ngIf="menu.menuDesc">
          <span>ℹ️</span>
          <span>{{ menu.menuDesc }}</span>
        </div>

        <!-- Menu Meta -->
        <div class="rn-notes-grid" *ngIf="menu.parentMenuId || menu.menuIconUrl || menu.templatePath">
          <div class="rn-note-block" *ngIf="menu.parentMenuId">
            <div class="rn-note-label">
              <span class="rn-label-dot exam"></span>
              Parent ID
            </div>
            <p>{{ menu.parentMenuId }}</p>
          </div>
          <div class="rn-note-block" *ngIf="menu.menuIconUrl">
            <div class="rn-note-label">
              <span class="rn-label-dot assess"></span>
              Icon
            </div>
            <p>{{ menu.menuIconUrl }}</p>
          </div>
          <div class="rn-note-block" *ngIf="menu.templatePath">
            <div class="rn-note-label">
              <span class="rn-label-dot plan"></span>
              Template
            </div>
            <p>{{ menu.templatePath }}</p>
          </div>
        </div>

        <!-- Timestamps -->
        <div class="rn-timestamps">
          <span class="rn-timestamp">📅 Created: {{ menu.createdOn | date: 'MMM d, y, h:mm a' }}</span>
          <span class="rn-timestamp" *ngIf="menu.modifiedOn">
            🔄 Updated: {{ menu.modifiedOn | date: 'MMM d, y, h:mm a' }}
          </span>
        </div>

      </div>
    </div>
  </div>

  <!-- ==============================
       PAGINATION
       ============================== -->
  <div class="rn-pagination-wrapper" *ngIf="!loading && filteredMenus.length > 0">

    <!-- Info -->
    <div class="rn-pagination-info">
      Showing <strong>{{ paginationStart }}</strong>–<strong>{{ paginationEnd }}</strong>
      of <strong>{{ filteredMenus.length }}</strong> menus
    </div>

    <!-- Controls -->
    <div class="rn-pagination-controls">

      <!-- Page size selector -->
      <div class="rn-page-size-wrap">
        <span class="rn-page-size-label">Rows:</span>
        <select
          class="rn-page-size"
          [value]="pageSize"
          (change)="onPageSizeChange($event)"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
        </select>
      </div>

      <!-- First page -->
      <button
        class="rn-page-nav"
        (click)="goToPage(1)"
        [disabled]="currentPage === 1"
        title="First page"
      >«</button>

      <!-- Previous -->
      <button
        class="rn-page-nav"
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        title="Previous page"
      >‹</button>

      <!-- Smart page numbers with ellipsis -->
      <ng-container *ngFor="let page of visiblePageNumbers">
        <span class="rn-page-ellipsis" *ngIf="page === -1">…</span>
        <button
          class="rn-page-number"
          *ngIf="page !== -1"
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
        >{{ page }}</button>
      </ng-container>

      <!-- Next -->
      <button
        class="rn-page-nav"
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        title="Next page"
      >›</button>

      <!-- Last page -->
      <button
        class="rn-page-nav"
        (click)="goToPage(totalPages)"
        [disabled]="currentPage === totalPages"
        title="Last page"
      >»</button>

    </div>
  </div>


  <!-- ==============================
       CREATE / EDIT MODAL
       ============================== -->
  <div class="rn-overlay" *ngIf="showModal">
    <div class="rn-modal">

      <!-- Header -->
      <div class="rn-modal-header">
        <div class="rn-modal-header-icon">{{ modalMode === 'create' ? '➕' : '✏️' }}</div>
        <div class="rn-modal-header-text">
          <h3>{{ modalMode === 'create' ? 'Create New Menu' : 'Edit Menu' }}</h3>
        </div>
        <button class="rn-close" (click)="closeModal()">×</button>
      </div>

      <!-- Body -->
      <div class="rn-modal-body">
        <form [formGroup]="menuForm" (ngSubmit)="submitForm()">

          <!-- Row 1: Name & Code -->
          <div class="rn-form-row two">
            <div class="rn-form-field">
              <label class="rn-label">Menu Name <i>*</i></label>
              <input type="text" formControlName="menuName" placeholder="Enter menu name" />
              <span class="rn-error" *ngIf="menuForm.get('menuName')?.invalid && menuForm.get('menuName')?.touched">
                Menu name is required (minimum 3 characters)
              </span>
            </div>
            <div class="rn-form-field">
              <label class="rn-label">Menu Code <i>*</i></label>
              <input type="text" formControlName="menuCode" placeholder="Enter menu code" />
              <span class="rn-error" *ngIf="menuForm.get('menuCode')?.invalid && menuForm.get('menuCode')?.touched">
                Menu code is required (minimum 2 characters)
              </span>
            </div>
          </div>

          <!-- Row 2: Description -->
          <div class="rn-form-row one">
            <div class="rn-form-field">
              <label class="rn-label">Description</label>
              <textarea formControlName="menuDesc" placeholder="Enter menu description"></textarea>
            </div>
          </div>

          <!-- Row 3: Display Order & Parent ID -->
          <div class="rn-form-row two">
            <div class="rn-form-field">
              <label class="rn-label">Display Order <i>*</i></label>
              <input type="number" formControlName="displayOrder" placeholder="0" min="0" />
              <span class="rn-error" *ngIf="menuForm.get('displayOrder')?.invalid && menuForm.get('displayOrder')?.touched">
                Display order must be a non-negative number
              </span>
            </div>
            <div class="rn-form-field">
              <label class="rn-label">Parent Menu ID</label>
              <input type="number" formControlName="parentMenuId" placeholder="0" />
            </div>
          </div>

          <!-- Row 4: Default Child & Icon URL -->
          <div class="rn-form-row two">
            <div class="rn-form-field">
              <label class="rn-label">Default Child Menu ID</label>
              <input type="number" formControlName="defaultChildMenuId" placeholder="0" />
            </div>
            <div class="rn-form-field">
              <label class="rn-label">Icon URL</label>
              <input type="text" formControlName="menuIconUrl" placeholder="https://example.com/icon.svg" />
            </div>
          </div>

          <!-- Row 5: Template Path -->
          <div class="rn-form-row one">
            <div class="rn-form-field">
              <label class="rn-label">Template Path</label>
              <input type="text" formControlName="templatePath" placeholder="/path/to/template" />
            </div>
          </div>

          <!-- Row 6: Active Status (Edit Only) -->
          <div class="rn-form-row one" *ngIf="modalMode === 'edit'">
            <div class="rn-form-field">
              <label class="rn-label">Status</label>
              <div class="rn-checkbox-group">
                <label class="rn-checkbox-label">
                  <input type="checkbox" formControlName="isActive" />
                  <span>Active</span>
                </label>
              </div>
            </div>
          </div>

          <!-- In-modal error -->
          <div class="rn-delete-context" *ngIf="errorMessage">
            <p><strong>Error:</strong> {{ errorMessage }}</p>
          </div>

        </form>
      </div>

      <!-- Footer -->
      <div class="rn-modal-footer">
        <div class="rn-footer-actions">
          <button class="rn-btn-cancel" (click)="closeModal()" [disabled]="submitting">Cancel</button>
          <button
            class="rn-btn-save"
            (click)="submitForm()"
            [disabled]="!isFormValid || submitting"
          >
            <span *ngIf="!submitting">{{ modalMode === 'create' ? 'Create Menu' : 'Update Menu' }}</span>
            <span *ngIf="submitting" style="display:inline-flex;align-items:center;gap:8px;">
              <span class="rn-spin" style="width:16px;height:16px;border-width:2px;border-color:rgba(255,255,255,0.3);border-top-color:#fff;"></span>
              Saving…
            </span>
          </button>
        </div>
      </div>

    </div>
  </div>


  <!-- ==============================
       DELETE CONFIRMATION MODAL
       ============================== -->
  <div class="rn-overlay" *ngIf="showDeleteModal">
    <div class="rn-modal rn-modal-sm">

      <!-- Header -->
      <div class="rn-modal-header rn-header-danger">
        <div class="rn-modal-header-icon">🗑️</div>
        <div class="rn-modal-header-text">
          <h3>Delete Menu</h3>
        </div>
        <button class="rn-close" (click)="closeDeleteModal()">×</button>
      </div>

      <!-- Body -->
      <div class="rn-modal-body">
        <div class="rn-delete-body">
          <div class="rn-delete-icon">🗑️</div>
          <p class="rn-delete-msg">
            Are you sure you want to delete <strong>{{ selectedMenu?.menuName }}</strong>?
          </p>
          <p class="rn-delete-sub">
            This action cannot be undone. The menu record will be permanently deleted.
          </p>
        </div>
      </div>

      <!-- Footer -->
      <div class="rn-modal-footer">
        <div class="rn-footer-actions">
          <button class="rn-btn-cancel" (click)="closeDeleteModal()" [disabled]="submitting">Cancel</button>
          <button
            class="rn-btn-delete"
            (click)="deleteMenu()"
            [disabled]="submitting"
          >
            <span *ngIf="!submitting">Delete Menu</span>
            <span *ngIf="submitting" style="display:inline-flex;align-items:center;gap:8px;">
              <span class="rn-spin" style="width:16px;height:16px;border-width:2px;border-color:rgba(255,255,255,0.3);border-top-color:#fff;"></span>
              Deleting…
            </span>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>